module.exports = __webpack_public_path__ + "static/media/memberCategory.svg";